import { isLocalUrl } from "@scalar/helpers/url/is-local-url";
//#region src/v2/blocks/scalar-auth-selector-block/helpers/is-allowed-oauth-url.ts
/** Allows HTTPS, with HTTP reserved for local development hosts and reserved test domains. */
var isAllowedOAuthUrl = (url) => url.protocol === "https:" || url.protocol === "http:" && isLocalUrl(url.href);
//#endregion
export { isAllowedOAuthUrl };

//# sourceMappingURL=is-allowed-oauth-url.js.map